import {HttpClient} from "../../service/httpClient/HttpClient";

export class ManagerService {
    constructor() {
        this.httpClient = new HttpClient()
    }

    getManagerList(page, size) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `admins`,
                {page, size}
            ).then(resolve).catch(reject)
        })
    }

    addNewManager(firstName, lastName, phoneNumber,
                  nationalCode, password, username,
                  rolesList, enabled) {


        let formData = new URLSearchParams()
        formData.append("firstName", firstName)
        formData.append("lastName", lastName)
        formData.append("nationalCode", nationalCode)
        formData.append("phoneNumber", phoneNumber)
        formData.append("username", username)
        formData.append("password", password)
        formData.append("roles", rolesList)
        formData.append("enabled", enabled)

        return new Promise((resolve, reject) => {
            new HttpClient(
                {},
                'application/x-www-form-urlencoded'
            ).post(
                `admins`,
                formData
            ).then(resolve).catch(reject)
        })

    }

    getProfileDetailById(adminId) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `admins/${adminId}`
            ).then(resolve).catch(reject)
        })
    }


    getManagerAvatar(managerId) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `admins/${managerId}/avatars`
            ).then(resolve).catch(reject)
        })
    }

    updateAdminAvatar(avatarFile, managerId) {
        return new Promise((resolve, reject) => {
            let data = new FormData()
            data.append('file', avatarFile)
            new HttpClient(
                {},
                "multipart/form-data"
            ).patch(`admins/${managerId}/avatars`,
                {}, data)
                .then(resolve).catch(reject)
        })
    }

    getManagerRolesList(managerId) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `admins/${managerId}/roles`
            ).then(resolve).catch(reject)
        })
    }

    updateManagerUserNameById(managerId, newUsername) {

        let formData = new URLSearchParams()
        formData.append("newUsername", newUsername)

        return new Promise((resolve, reject) => {
            new HttpClient(
                {},
                "application/x-www-form-urlencoded"
            ).patch(
                `admins/${managerId}/username`,
                {},
                formData
            ).then(resolve).catch(reject)
        })
    }


    changeManagerPasswordById(managerId, newPassword) {

        let formData = new URLSearchParams()
        formData.append("newPassword", newPassword)

        return new Promise((resolve, reject) => {
            new HttpClient({}, "application/x-www-form-urlencoded").put(
                `admins/${managerId}/password`,
                formData,
            ).then(resolve).catch(reject)
        })
    }

    getManagerEnabled(managerId) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `admins/${managerId}/enabled`
            ).then(resolve).catch(reject)
        })
    }


    updateManagerRoles(managerId, roles) {
        return new Promise((resolve, reject) => {
            this.httpClient.patch(
                `admins/${managerId}/roles`,
                {},
                {
                    roles
                }
            ).then(resolve).catch(reject)
        })
    }


    changeManagerEnabledState(managerId, enabled) {
        return new Promise((resolve, reject) => {
            this.httpClient.patch(
                `admins/${managerId}/enabled`,
                {},
                {
                    enabled
                }
            ).then(resolve).catch(reject)
        })
    }

    updateProfileDetailById(adminId, profileJsonInfo) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `admins/${adminId}`,
                profileJsonInfo,
            ).then(resolve).catch(reject)
        })

    }


}